import * as uuid from 'uuid';
import Content from '../../content.js';
import Messenger from '../../components/messenger.js';

class NodesExport extends Content {
  get dom() {
    return {
      SELECT_ALL: '#all-selected',
      SELECT_SECTION: '.section-all-select',
      CHECKBOX: '.alone-checkbox',
      FORM: '#node-export-form',
      EXPORT_BUTTON: '#select-exported-fields-btn',
      TOKEN: '#download_token',
    };
  }

  get events() {
    let events = [];

    events[`change ${this.dom.CHECKBOX}`] = '_checkboxChanged';
    events[`change ${this.dom.SELECT_SECTION}`] = '_sectionChanged';
    events[`change ${this.dom.SELECT_ALL}`] = '_selectAllChanged';
    events[`click ${this.dom.EXPORT_BUTTON}`] = '_disableExportButton';
    return events;
  }

  _checkboxChanged(evt) {
    this._handleSelectAll();
    this._handleSection($(evt.target).data('section'));
    this._handleChild(evt);
  }

  _handleSelectAll() {
    let checked =
      $(this.dom.CHECKBOX).length == $(this.dom.CHECKBOX + ' :checked').length;

    $(this.dom.SELECT_ALL).prop('checked', checked);
  }

  _disableExportButton() {
    let listener;
    const token = uuid.v4().replace(/-/g, '');

    listener = () => {
      $(this.dom.EXPORT_BUTTON).removeClass('disabled loading');
      Messenger.off(`/node_export/${token}`, listener);
    };
    Messenger.on(`/node_export/${token}`, listener);

    $(this.dom.TOKEN).val(token);
    $(this.dom.EXPORT_BUTTON).addClass('disabled loading');
    $(this.dom.FORM).trigger('submit');
  }

  _handleSection(section) {
    let selector = '.' + section + '_checkbox',
      selectAll = $('.section-all-select[data-section="' + section + '"]');

    selectAll.prop(
      'checked',
      $(selector).length == $(selector + ':checked').length,
    );
  }

  _handleChild(evt) {
    let $child = $('#' + evt.target.id + '_running_version'),
      checked = $(evt.target).is(':checked');

    $child
      .prop('checked', checked)
      .prop('disabled', !checked)
      .trigger('change');
  }

  _sectionChanged(evt) {
    var section = $(evt.target).data('section'),
      checked = $(evt.target).is(':checked');

    $('.' + section + '_checkbox').prop('checked', checked);
    $('.' + section + '_metadata_checkbox').prop('disabled', !checked);
    this._handleSelectAll();
  }

  _selectAllChanged(evt) {
    $(this.dom.SELECT_SECTION)
      .prop('checked', $(evt.target).is(':checked'))
      .trigger('change');
  }

  render() {
    this._handleSection('dynamic');
    this._handleSelectAll();
  }
}

module.exports = NodesExport;
